import { ethers } from "ethers";
// 假设您的 ABI 在本地，路径需要根据您的项目调整
import LuckyPoolABI from "../abis/LuckyPool.json"; // 假设接口对应的 ABI 文件名为 LuckyPool.json

/**
 * LuckyPool 合约的 ethers.js 封装
 */
export class LuckyPoolContract {
  /**
   * @type {ethers.Contract}
   */
  contract;

  /**
   * @param {string} contractAddress 合约地址
   * @param {ethers.Provider | ethers.Signer} providerOrSigner ethers 提拱者或签名者
   */
  constructor(contractAddress, providerOrSigner) {
    this.contract = new ethers.Contract(
      contractAddress,
      LuckyPoolABI.abi, // 替换为实际的 ABI JSON
      providerOrSigner
    );
  }

  // ------------------------------------
  // ⬇️ 读接口 (View Functions - Public Variables)
  // ------------------------------------

  /**
   * 获取幸运数字 (luckyNumber)
   * @returns {Promise<ethers.BigNumber>} 幸运数字 (uint64)
   */
  async getLuckyNumber() {
    try {
      // 合约公共变量: uint64 public luckyNumber
      const luckyNumber = await this.contract.luckyNumber();
      return luckyNumber;
    } catch (error) {
      console.error("Error fetching luckyNumber:", error);
      throw error;
    }
  }

  /**
   * 获取幸运赢家地址 (luckyWinner)
   * @returns {Promise<string>} 幸运赢家地址
   */
  async getLuckyWinner() {
    try {
      // 合约公共变量: address public luckyWinner
      return await this.contract.luckyWinner();
    } catch (error) {
      console.error("Error fetching luckyWinner:", error);
      throw error;
    }
  }

  /**
   * 获取 AroundPoolFactory 合约地址 (aroundPoolFactory)
   * @returns {Promise<string>} AroundPoolFactory 合约地址
   */
  async getAroundPoolFactory() {
    try {
      // 合约公共变量: address public aroundPoolFactory
      return await this.contract.aroundPoolFactory();
    } catch (error) {
      console.error("Error fetching aroundPoolFactory address:", error);
      throw error;
    }
  }

  /**
   * 检查是否已提款 (ifWithdraw)
   * @returns {Promise<boolean>} 是否已提款
   */
  async getIfWithdraw() {
    try {
      // 合约公共变量: bool public ifWithdraw
      return await this.contract.ifWithdraw();
    } catch (error) {
      console.error("Error fetching ifWithdraw status:", error);
      throw error;
    }
  }

  // ------------------------------------
  // ⬇️ 写接口 (Transaction Functions)
  // ------------------------------------

  /**
   * 调用 bump 函数，通常用于触发某些逻辑，例如幸运数字的生成或抽奖
   * @param {ethers.BigNumberish} thisMarketId 市场 ID
   * @param {ethers.Overrides} [overrides] 交易覆盖选项 (如 gasLimit, gasPrice, value)
   * @returns {Promise<ethers.ContractTransaction>} 交易对象
   */
  async bump(thisMarketId, overrides = {}) {
    // 确保有 signer (签名者) 才能发送交易（ethers v6 使用 runner）
    const canSend =
      !!this.contract.runner && typeof this.contract.runner.sendTransaction === 'function';
    if (!canSend) {
      throw new Error("Signer is required for sending transactions like 'bump'.");
    }
    
    try {
      // 合约函数签名: function bump(uint256 thisMarketId) external
      return await this.contract.bump(thisMarketId, overrides);
    } catch (error) {
      console.error("Error executing bump transaction:", error);
      // 抛出错误以便上层捕获和处理
      throw error;
    }
  }
}
